<template>
    <div
        class="grow lg:h-full bg-white flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <img src="/app/img/green-circle.png" class="background-circle" />

        <div class="mx-auto w-full z-50">
            <slot></slot>
        </div>

    </div>
</template>

<script>
export default { };
</script>

<style scoped>
.background-circle {
    position:fixed;
    bottom: 0px;
    left: 0px;
}
</style>
